<template>
    <AuthLayout :fo_config="fo_config" :settingsConfig="settingsConfig" :fo_content="fo_content">
        <div v-if="!user && (!this.settingsConfig['FORM_POSITION'] || this.settingsConfig['FORM_POSITION'] == 0)">
            <sign-in @forgottenPassword="handleShowForgottenPassword" @signed-up="handleSignUp" @userLogin="set_user($event)" @signUp="signup = $event" v-show="!signup"></sign-in>
            <sign-up :config="config" @signed-up="handleSignUp" :withAuth="true" @sign-in="signup = $event" v-show="signup"></sign-up>
            <ForgottenPassword v-show="onForgotten_password" @showSignIn="handleShowSignIn"></ForgottenPassword>
        </div>
    </AuthLayout>
</template>

<script>
    import AuthLayout from './AuthLayout.vue';
    import { Inertia } from '@inertiajs/inertia';
    import SignIn from '../Profile/SignIn.vue';
    import SignUp from '../Profile/SignUp.vue';
    import ForgottenPassword from './ForgottenPassword.vue';

      export default {
        name: 'AuthPage',
        props: ['config', 'fo_config', "settingsConfig", 'fo_content'],
        components: {SignIn, SignUp, AuthLayout, ForgottenPassword},
        data(){
            return {
                signup: false,
                onForgotten_password: false,
            }
        },
        computed: {
            page_config () {
                return this.$page.props.config
            },
            user() {
                return this.$page.props.auth.user?.client?.[0]
            },
            redirected(){
                return this.fo_config && (this.fo_config['redirected'] == 1);
            },
            redirect_params(){
                if(!this.redirected){
                    return '';
                }
                let url = window.location.href;
                // let params = url.substring(url.lastIndexOf('/')+1).replace('times','');
                let params = url.split('?',2)[1];
                return params+'&redirected=1';
            }
        },
        methods: {
            handleSignUp() {                
                Inertia.get("/account")
            },
            handleShowSignIn() {
                this.signup = false;
                this.onForgotten_password = false;
            },
            handleShowForgottenPassword() {
                this.signin = false;
                this.onForgotten_password = true;
            },
            applyStyleVars() {
                Object.entries(this.fo_content).forEach(([key, value]) => {
                    const cssVarName = `${key.replace(/_/g, '-')}`
                    document.documentElement.style.setProperty(cssVarName, value)
                    console.log(cssVarName);
                    
                })
            },
        },
        beforeMount() {
            if (this.user) {
                this.$inertia.get('/account')    
            }
        },
        mounted() {
            this.applyStyleVars()
            console.log('settingConfig', this.settingsConfig, this.settingsConfig['FORM_POSITION']);
        }
    }
</script>